<script setup lang="ts">
interface EventBubble {
  count: number;
}

defineProps<EventBubble>();
</script>

<template>
  <div class="event-bubble__circle">
    <div class="event-bubble__text">{{ count }}</div>
  </div>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
.event-bubble {
  &__circle {
    padding-top: 2px;
    background-color: #ada6b73b;
    border-radius: 50%;
    width: 25px;
    height: 25px;
  }

  &__text {
    padding-top: 1px;
    color: #ffffff;
    font-size: 12px;
  }
}
</style>
